/**
 * Intercepteur global pour tous les appels fetch
 * S'assure que le token d'authentification est automatiquement ajouté
 */

// Sauvegarder la fonction fetch originale
const originalFetch = window.fetch;

// Remplacer fetch par une version qui ajoute automatiquement le token
window.fetch = function (url, options = {}) {
  // Vérifier si c'est un appel vers notre API
  if (url.includes("localhost:3000/api")) {
    console.log("🔍 Appel API détecté:", url);

    // Récupérer le token depuis localStorage
    const token = localStorage.getItem("token");

    if (token) {
      // Ajouter le token aux headers
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      console.log(
        "🔑 Token ajouté automatiquement:",
        token.substring(0, 20) + "..."
      );
    } else {
      console.log("❌ Pas de token trouvé pour l'appel API");
    }
  }

  // Appeler la fonction fetch originale avec les options modifiées
  return originalFetch(url, options);
};

console.log("✅ Intercepteur fetch global activé");

export default window.fetch;
